import { render, staticRenderFns } from "./SecretaryCallbackPhoneSection.vue?vue&type=template&id=2fcc2580&scoped=true&"
import script from "./SecretaryCallbackPhoneSection.vue?vue&type=script&lang=js&"
export * from "./SecretaryCallbackPhoneSection.vue?vue&type=script&lang=js&"
import style0 from "./SecretaryCallbackPhoneSection.vue?vue&type=style&index=0&id=2fcc2580&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcc2580",
  null
  
)

export default component.exports